import { MessengerMessageRow } from '@/components/Messenger/shared/messages/MessengerMessageRow';
import { PulsingIndicator } from '@/components/Messenger/agent/PulsingIndicator';

export type AgentProcessingStatusRowProps = {
  statusText: string;
};

/** Единый слот статуса агента в полотне чата (без отдельного «стрим-бабла» контента). */
export function AgentProcessingStatusRow({ statusText }: AgentProcessingStatusRowProps) {
  if (!statusText.trim()) return null;
  return (
    <MessengerMessageRow alignment="assistant">
      <div className="chatAssistant__message chatAssistant__message_thinking">
        <PulsingIndicator text={statusText} />
      </div>
    </MessengerMessageRow>
  );
}
